<template>
  <c-modal v-if="site" class="edit-site" :title="title" size="lg" :show="show" @update:show="toggle">
    <c-tabs>
      <c-tab title="Details" active>
        <c-row class="p-3">
          <c-col>
            <edit-details :site="site" />
          </c-col>
        </c-row>
      </c-tab>
      <c-tab title="HTTP Authentication">
        <c-row class="p-3">
          <c-col>
            <edit-authentication :site="site" />
          </c-col>
        </c-row>
      </c-tab>
      <c-tab title="Backup">
        <c-row class="p-3">
          <c-col>
            <edit-backup :site="site" />
          </c-col>
        </c-row>
      </c-tab>
    </c-tabs>
  </c-modal>
</template>

<script>
import EditDetails from '@/views/components/site/edit-details';
import EditAuthentication from '@/views/components/site/edit-authentication';
import EditBackup from '@/views/components/site/edit-backup';

export default {
  name: 'EditSite',
  components: {
    EditAuthentication,
    EditDetails,
    EditBackup,
  },
  props: {
    show: Boolean,
    site: Object,
  },
  data() {
    return {};
  },
  computed: {
    title() {
      return `Edit ${this.site.name}`;
    },
  },
  methods: {
    toggle(event) {
      if (!event) {
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss">
.edit-site .modal-footer {
  display: none !important;
}
</style>
